import { render, staticRenderFns } from "./VideoLink.vue?vue&type=template&id=a91afc5c&scoped=true&"
import script from "./VideoLink.vue?vue&type=script&lang=js&"
export * from "./VideoLink.vue?vue&type=script&lang=js&"
import style0 from "./VideoLink.vue?vue&type=style&index=0&id=a91afc5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91afc5c",
  null
  
)

export default component.exports